import { velocityHelpers } from 'velocity-react';

const flipYHeightTransitions = {
    enter: velocityHelpers.registerEffect({
        calls: [
            [{
                transformPerspective: [ 800, 800 ],
                transformOriginX: [ '50%', '50%' ],
                transformOriginY: [ '0', '0' ],
                marginBottom: 0,
                opacity: 1,
                rotateX: [0, 130],
            }, 1, {
                easing: 'ease-out',
                display: 'block',
            }]
        ]
    }),
    leave: velocityHelpers.registerEffect({
        calls: [
            [{
                transformPerspective: [ 800, 800 ],
                transformOriginX: [ '50%', '50%' ],
                transformOriginY: [ '0%', '0%' ],
                marginBottom: -60,
                opacity: 0,
                rotateX: -70,
            }, 1, {
                easing: 'ease-out',
                display: 'block',
            }]
        ],
    })
};

export const sliderTransition = direction => ({
    enter: {
        animation: `transition.expandIn`,
        duration: '300',
    },
    leave: {
        animation: `transition.expandOut`,
        duration: '300'
    }
});
export const fadeTransition = () => ({
    enter: {
        animation: `transition.fadeIn`,
        duration: '500'
    },
    leave: {
        animation: `transition.fadeOut`,
        duration: '500'
    }
});
export const flipYTransition = direction => ({
    enter: {
        animation: `transition.flipYIn`,
        duration: '500', stagger: '100'
    },
    leave: {
        animation: `transition.flipYOut`,
        backwards: true, duration: '300', stagger: '100'
    }
});
export const flipYHeight = () => ({
    enter: {
        animation: flipYHeightTransitions.enter,
        duration: '300', stagger: '100'
    },
    leave: {
        animation: flipYHeightTransitions.leave,
        backwards: true, duration: '300', stagger: '100'
    }
});
export const zoomTransition = () => ({
    enter: {
        animation: `transition.shrinkIn`,
        duration: '500', delay: 300
    },
    leave: {
        animation: `transition.expandOut`,
        duration: '400'
    }
});

export default sliderTransition;



// WEBPACK FOOTER //
// ./ui/transitions/slider.js